import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "24",
  viewBox: "0 0 23 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Group" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M21.8047 12.1147L11.3047 1.61475H1.30469V11.6147L11.8047 22.1147L21.8047 12.1147Z",
        stroke: "#454342",
        "stroke-width": "1.5",
        "stroke-miterlimit": "10",
        "stroke-linecap": "square"
      }),
      _createElementVNode("path", {
        id: "Vector_2",
        d: "M8.41696 7.6704C8.41696 8.25368 7.94411 8.72653 7.36083 8.72653C6.77754 8.72653 6.30469 8.25368 6.30469 7.6704C6.30469 7.08711 6.77754 6.61426 7.36083 6.61426C7.94411 6.61426 8.41696 7.08711 8.41696 7.6704Z",
        fill: "#454342",
        stroke: "#454342",
        "stroke-width": "1.5"
      })
    ], -1)
  ])))
}
export default { render: render }